var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_52",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.986328 0H64.9863V64H0.986328V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.533 0H17.4183V2.85067H20.0583V0H22.9436V8.62933H20.0583V5.74133H17.4183V8.62933H14.5356L14.533 0ZM26.7356 2.86133H24.197V0H32.1623V2.86133H29.621V8.62933H26.7356V2.86133ZM33.4263 0H36.4343L38.285 3.032L40.133 0H43.141V8.62933H40.269V4.352L38.285 7.42133H38.2343L36.2476 4.35467V8.62933H33.4263V0ZM44.5756 0H47.4636V5.77867H51.517V8.632H44.5756V0Z",
    fill: "#94535C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4423 58.8587L8.98633 12.5787H56.9863L51.5277 58.8533L32.9597 64L14.4423 58.8587ZM25.4743 33.5253L24.957 27.712H46.677L47.1837 22.0373H18.757L20.2877 39.2027H39.9597L39.301 46.5627L32.9703 48.2747H32.965L26.645 46.568L26.2397 42.0427H20.5383L21.333 50.9547L32.9597 54.1813L44.605 50.9547L46.0237 35.0507L46.1623 33.528L25.4743 33.5253Z",
    fill: "#94535C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.87aae61845d3784f9e05fa847f4b6642.svg";
export { ForwardRef as ReactComponent };